import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import "./SalesInTotalForm.scss";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { useHistory, useParams } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import ClientsModal from "../ClientsCRUD/ClientsModal";
import { getUnitID } from "../../Auth/GetUnitCompany";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import CircularProgress from "@mui/material/CircularProgress";
import { useVatDeclarant } from "../../GetData/Context/CompanyDataContext";
import AccountsAutocompleteEdit from "../../Components/AccountsAutocompleteEdit";
import AccountsAutocompleteInsert from "../../Components/AccountsAutocompleteInsert";
import PriceField from "../../Components/NumberFieldFormater";
import PaymentTypeSelect from "../../Components/PaymentTypeSelect";

const formatEuroValue = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const round2 = (value) => {
  const parsed = Number(value || 0);
  if (!Number.isFinite(parsed)) {
    return 0;
  }
  return Math.round((parsed + Number.EPSILON) * 100) / 100;
};

const createEmptySnapshot = () => ({
  invoiceNR: "",
  date: "",
  payDate: "",
  clientID: "",
  paymentOptions: "",
  transactionType: 1,
  coment: "",
  amount0: 0,
  amount8: 0,
  amount18: 0,
  vat8: 0,
  vat18: 0,
  valueWithVAT0: 0,
  valueWithVAT8: 0,
  valueWithVAT18: 0,
});

const createSnapshotWithInvoice = (invoiceValue = "") => ({
  ...createEmptySnapshot(),
  invoiceNR: String(invoiceValue || ""),
});

function SalesInTotalForm(props) {
  const history = useHistory();
  const { transactionId } = useParams();
  const isEditMode = Boolean(transactionId);

  const TranscationData = [
    {
      id: 1,
      type: "Vendore",
    },
    {
      id: 2,
      type: "Eksport",
    },
        {
      id: 3,
      type: "Sherbime jashtë vendit",
    },
    {
      id: 4,
      type: "Ngarkesa e Kundert",
    },
  ];

  const headers = useMemo(() => authHeader(), []);
  const email = LoginUserDetailed();
  const { fiscalYear } = useContext(FiscalYearContext);
  const isVatDeclarant = useVatDeclarant();
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDare] = useState("");

  useEffect(() => {
    setMinDate(`${fiscalYear}-01-01`);
    setMaxDare(`${fiscalYear}-12-31`);
  }, [fiscalYear]);

  const [date, setDate] = useState("");
  const [payDate, setPayDate] = useState("");
  const [invoiceNR, setInvoiceNR] = useState("");
  const [clientID, setClientID] = useState("");
  const [amount0, setAmount0] = useState(0);
  const [amount8, setAmount8] = useState(0);
  const [amount18, setAmount18] = useState(0);
  const [vat8, setVat8] = useState(0);
  const [vat18, setVat18] = useState(0);
  const [coment, setComent] = useState("");
  const [paymentOptions, setPaymentOptions] = useState("");
  const [validationErrors, setValidationErrors] = useState({
    invoiceNR: "",
    date: "",
    payDate: "",
    clientID: "",
    paymentOptions: "",
  });
  const [transactionType, setTransactionType] = useState(1);
  const [unId, setUnID] = useState("");

  const invoiceNrRef = useRef(null);

  const [insertingTransaction, setInsertingTransaction] = useState(false);
  const [isInitializing, setIsInitializing] = useState(isEditMode);
  const [editingTransactionId, setEditingTransactionId] = useState("");
  const [initialInvoiceNr, setInitialInvoiceNr] = useState("");
  const [showClientModal, setShowClientModal] = useState(false);
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);
  const [duplicateInvoiceDialog, setDuplicateInvoiceDialog] = useState({
    open: false,
    title: "",
    message: "",
    details: "",
  });
  const [fiscalDateDialog, setFiscalDateDialog] = useState({
    open: false,
    title: "",
    message: "",
    details: "",
  });
  const [initialFormSnapshot, setInitialFormSnapshot] = useState(
    createEmptySnapshot(),
  );



  const resetCreateForm = (nextInvoiceNr = "") => {
    setDate("");
    setPayDate("");
    setInvoiceNR(String(nextInvoiceNr || ""));
    setClientID("");
    setComent("");
    setPaymentOptions("");
    setAmount0(0);
    setAmount8(0);
    setAmount18(0);
    setTransactionType(1);
    setValueWithVAT0(0);
    setValueWithVAT8(0);
    setValueWithVAT18(0);
    setVat8(0);
    setVat18(0);
    setField(null);
    setInvNumberExist(undefined);
    setInvoiceOtherClientMessage("");
    setValidationErrors({
      invoiceNR: "",
      date: "",
      payDate: "",
      clientID: "",
      paymentOptions: "",
    });
    setInitialFormSnapshot(createSnapshotWithInvoice(nextInvoiceNr));
  };

  const fetchNextInvoiceNr = async ({ resetForm = false } = {}) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "SalesInTotal/GetNextInvoiceNR",
        {
          headers,
          params: { fiscalYear },
        },
      );

      const nextInvoice = response?.data?.NextInvoiceNR;
      if (nextInvoice != null) {
        const normalizedInvoice = String(nextInvoice);

        if (resetForm) {
          resetCreateForm(normalizedInvoice);
        } else {
          setInvoiceNR(normalizedInvoice);
          setInitialFormSnapshot(createSnapshotWithInvoice(normalizedInvoice));
        }

        return normalizedInvoice;
      }
    } catch (error) {
      // Keep current value when auto-generation endpoint is unavailable.
    }

    return "";
  };

  const formatDate = (isoValue) => {
    if (!isoValue) return "";
    const [y, m, d] = isoValue.split("-");
    return `${d}.${m}.${y}`;
  };

  const isDateOutsideFiscalYear = (value) => {
    if (!value || !minDate || !maxDate) {
      return false;
    }

    return value < minDate || value > maxDate;
  };

  const isInvoiceDateOutsideFiscalYear = isDateOutsideFiscalYear(date);

  const openFiscalDateDialog = (fieldLabel, value) => {
    setFiscalDateDialog({
      open: true,
      title: "Data nuk përputhet me vitin fiskal",
      message: `${fieldLabel} duhet të jetë brenda vitit fiskal ${fiscalYear}.`,
      details: `Ju keni përzgjedhur ${formatDate(value)}. Ju lutem vendosni një datë nga ${formatDate(minDate)} deri më ${formatDate(maxDate)} për të vazhduar me ruajtjen e faturës.`,
    });
  };

  const validateBeforeSubmit = () => {
    const nextErrors = {
      invoiceNR: "",
      date: "",
      payDate: "",
      clientID: "",
      paymentOptions: "",
    };

    if (!invoiceNR) {
      nextErrors.invoiceNR = "Numri i faturës është i detyrueshëm.";
    }
    if (!date) {
      nextErrors.date = "Data e faturës është e detyrueshme.";
    }
    if (!payDate) {
      nextErrors.payDate = "Data e pagesës është e detyrueshme.";
    }
    if (!clientID) {
      nextErrors.clientID = "Ju lutem zgjidhni klientin.";
    }
    if (!paymentOptions) {
      nextErrors.paymentOptions = "Ju lutem zgjidhni mënyrën e pagesës.";
    }
    if (Object.values(nextErrors).some(Boolean)) {
      setValidationErrors(nextErrors);
      return false;
    }

    setValidationErrors({
      invoiceNR: "",
      date: "",
      payDate: "",
      clientID: "",
      paymentOptions: "",
    });

    return true;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setInsertingTransaction(true);

    if (!validateBeforeSubmit()) {
      setInsertingTransaction(false);
      return;
    }

    if (isInvoiceDateOutsideFiscalYear) {
      openFiscalDateDialog("Data e faturës", date);
      setInsertingTransaction(false);
      return;
    }

    const stateDate = {
      Date: date,
      PayDate: payDate,
      ActionType: "INT",
      InvoiceNr: invoiceNR,
      SupplierID: Number(clientID || 0),
      Amount0: Number(amount0 || 0),
      Amount8: Number(amount8 || 0),
      Amount18: Number(amount18 || 0),
      PaymentOptions: Number(paymentOptions || 0),
      TransactionType: Number(transactionType || 1),
      CompanyUnitID: Number(unId) > 0 ? Number(unId) : null,
      Coment: coment,
      ...(isEditMode
        ? {
            TransactionID: Number(editingTransactionId || transactionId),
            ModifiedByUser: email,
          }
        : {
            CreatedByUser: email,
          }),
    };
    const request = isEditMode
      ? axios.put(
          ApiLink.API_URL + "SalesInTotal/update-sales-in-total",
          {
            ...stateDate,
            AccountID: Number(clientID),
            PaymentOptions: Number(paymentOptions || 0),
            TransactionType: Number(transactionType || 1),
          },
          { headers },
        )
      : axios.post(
          ApiLink.API_URL + "SalesInTotal/insert-sales-in-total",
          stateDate,
          { headers },
        );

    request
      .then(() => {
        handleSuccess(
          isEditMode
            ? "Shitja në total u përditësua me sukses"
            : "Shitja në total u shtua me sukses",
        );

        if (isEditMode) {
          closePage();
          return;
        }

        fetchNextInvoiceNr({ resetForm: true });
        setInsertingTransaction(false);
      })
      .catch((error) => {
        setInsertingTransaction(false);
        if (error.response && error.response.status === 409) {
          const backendMessage =
            typeof error.response.data === "string" && error.response.data.trim()
              ? error.response.data.trim()
              : "Ky numër i faturës ekziston tashmë për këtë vit fiskal.";

          if (!isEditMode) {
            fetchNextInvoiceNr({ resetForm: false });
          }

          setDuplicateInvoiceDialog({
            open: true,
            title: !isEditMode
              ? "Numri i faturës u rifreskua"
              : "Numri i faturës ekziston",
            message: backendMessage,
            details: !isEditMode
              ? "Sistemi gjeneroi automatikisht një numër të ri të faturës. Të dhënat e formularit mbetën të pandryshuara dhe mund ta vazhdoni ruajtjen menjëherë."
              : "Ju lutem verifikoni numrin e faturës dhe provoni përsëri pasi të bëni korrigjimin e nevojshëm.",
          });
        } else {
          errorAlert(
            isEditMode
              ? "Ndodhi gabim gjatë përditësimit të shitjes në total."
              : "Ndodhi gabim gjatë ruajtjes së shitjes në total.",
          );
        }
      });
  };

  //   const fetchClients = async () => {
  //     try {
  //       const response = await axios.get(
  //         ApiLink.API_URL + "Accounts/accountByLedger",
  //         { headers, params: { ledger: 302 } },
  //       );
  //       setClients(response.data);
  //     } catch (error) {
  //       errorAlert("Gabim në kërkesë:", error);
  //       if (
  //         error.response &&
  //         error.response.data &&
  //         error.response.data.errorMessage
  //       ) {
  //         errorAlert(
  //           `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
  //         );
  //       } else if (error.message) {
  //         errorAlert(`Gabim: ${error.message} `);
  //       } else {
  //         errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //       }
  //     }
  //   };



  // ky kod sherben per ta kontrolluar nese nje numer i fatures ekzison, dhe e vendos butoni se qfar pamje do te merr
  const [invNumberExist, setInvNumberExist] = useState();
  const [invoiceOtherClientMessage, setInvoiceOtherClientMessage] = useState("");

  const [valueWithVAT0, setValueWithVAT0] = useState(0);
  const [valueWithVAT8, setValueWithVAT8] = useState(0);
  const [valueWithVAT18, setValueWithVAT18] = useState(0);

  const currentFormSnapshot = useMemo(
    () => ({
      invoiceNR: invoiceNR || "",
      date: date || "",
      payDate: payDate || "",
      clientID: String(clientID || ""),
      paymentOptions: String(paymentOptions || ""),
      transactionType: Number(transactionType || 1),
      coment: coment || "",
      amount0: round2(amount0),
      amount8: round2(amount8),
      amount18: round2(amount18),
      vat8: round2(vat8),
      vat18: round2(vat18),
      valueWithVAT0: round2(valueWithVAT0),
      valueWithVAT8: round2(valueWithVAT8),
      valueWithVAT18: round2(valueWithVAT18),
    }),
    [
      invoiceNR,
      date,
      payDate,
      clientID,
      paymentOptions,
      transactionType,
      coment,
      amount0,
      amount8,
      amount18,
      vat8,
      vat18,
      valueWithVAT0,
      valueWithVAT8,
      valueWithVAT18,
    ],
  );

  const isFormDirty = useMemo(
    () =>
      JSON.stringify(currentFormSnapshot) !==
      JSON.stringify(initialFormSnapshot),
    [currentFormSnapshot, initialFormSnapshot],
  );

  const closePage = () => {
    history.push("/Sales/salesintotal");
  };

  const closeDuplicateInvoiceDialog = () => {
    setDuplicateInvoiceDialog({
      open: false,
      title: "",
      message: "",
      details: "",
    });
  };

  const closeFiscalDateDialog = () => {
    setFiscalDateDialog({
      open: false,
      title: "",
      message: "",
      details: "",
    });
  };

  const handleCloseClick = () => {
    if (isFormDirty) {
      setShowCloseConfirm(true);
      return;
    }
    closePage();
  };

  const calculateWithoutVAT = async (withVAT, vat) => {
    try {
      const noVAT =
        (Number(withVAT) * Number(100)) / (Number(100) + Number(vat));
      const vatTotal = Number(withVAT) - Number(noVAT);

      if (vat == 0) {
        setAmount0(noVAT);
      } else if (vat == 8) {
        setAmount8(noVAT);
        setVat8(vatTotal);
      } else if (vat == 18) {
        setAmount18(noVAT);
        setVat18(vatTotal);
      }
    } catch (error) {
      console.error("Error during calculation:", error);
      // Perform any necessary error handling here
    }
  };

  const calculateWithVAT = async (withoutVAT, vat) => {
    try {
      const vatTotal = Number(withoutVAT) * (Number(vat) / Number(100));
      const withVAT = Number(withoutVAT) + Number(vatTotal);

      if (vat == 0) {
        setValueWithVAT0(withVAT);
      } else if (vat == 8) {
        setValueWithVAT8(withVAT);
        setVat8(vatTotal);
      } else if (vat == 18) {
        setValueWithVAT18(withVAT);
        setVat18(vatTotal);
      }
    } catch (error) {
      console.error("Error during calculation:", error);
      // Perform any necessary error handling here
    }
  };

  const calculateFromVAT = async (vatValue, vat) => {
    try {
      const withoutVAT = Number(vatValue) / (Number(vat) / Number(100));
      const totalAmount = Number(withoutVAT) + Number(vatValue);

      if (vat == 0) {
        setValueWithVAT0(totalAmount);
        setAmount0(withoutVAT);
      } else if (vat == 8) {
        setValueWithVAT8(totalAmount);
        setAmount8(withoutVAT);
      } else if (vat == 18) {
        setValueWithVAT18(totalAmount);
        setAmount18(withoutVAT);
      }
    } catch (error) {
      console.error("Error during calculation:", error);
      // Perform any necessary error handling here
    }
  };
  //Pjesa per select input field Clients
  const [field, setField] = useState(null);
  //   const handleAutocompleteChangeClients = (event, value) => {
  //     if (value && value.AccountID) {
  //       setClientID(value.AccountID);
  //       setField(value);
  //     } else {
  //       // Në rast se vlera është pastruar
  //       setClientID(""); // Vendos vlerën e ArticleID në null
  //     }
  //   };

  //   const defaultPropsClients = {
  //     options: clients,
  //     getOptionLabel: (option) =>
  //       `${option.IdentificationNumber} - ${option.AccountName}` || "",
  //     renderOption: (props, option) => (
  //       <>
  //         <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //           <span>
  //             {option.IdentificationNumber}
  //             <br />
  //             {option.AccountName}
  //           </span>
  //         </li>
  //       </>
  //     ),
  //   };

  //E merr unit id nga nje klas tjeter
  useEffect(() => {
    getUnitID(headers).then(setUnID);
  }, [headers]);

  const paymentMenuProps = {
    PaperProps: {
      sx: {
        maxHeight: 280,
        maxWidth: "min(460px, calc(100vw - 32px))",
        mt: 0.5,
        overflowY: "auto",
        borderRadius: "10px",
        "& .MuiMenuItem-root": {
          fontSize: "13px",
          minHeight: 36,
          whiteSpace: "normal",
          wordBreak: "break-word",
        },
      },
    },
  };

  const sharedDropdownIcon = (props) => (
    <svg
      {...props}
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#4E7B67"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );

  const sharedSelectInputSx = {
    borderRadius: 8,
    height: 48,
    minHeight: 48,
    maxHeight: 48,
    background: '#f5f9f7',
    borderColor: '#d4e2db',
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4E7B67',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4E7B67',
    },
    '& .MuiSelect-select, & .MuiInputBase-input': {
      height: 48,
      minHeight: 48,
      maxHeight: 48,
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      padding: '0 14px',
    },
  };

  useEffect(() => {
    if (isEditMode) {
      return;
    }

    fetchNextInvoiceNr({ resetForm: true }).then(() => {
      invoiceNrRef.current?.focus();
    });
  }, [isEditMode, fiscalYear]);

  useEffect(() => {
    if (!isInitializing) {
      invoiceNrRef.current?.focus();
    }
  }, [isInitializing]);

  useEffect(() => {
    if (!isEditMode) {
      setInitialFormSnapshot(createEmptySnapshot());
    }
  }, [isEditMode]);

  useEffect(() => {
    if (isEditMode) {
      setInvNumberExist(0);
      setInvoiceOtherClientMessage("");
      return;
    }

    if (!invoiceNR) {
      setInvNumberExist(0);
      setInvoiceOtherClientMessage("");
      return;
    }

    let isCancelled = false;

    const validateInvoice = async () => {
      try {
        const response = await axios.get(ApiLink.API_URL + "SalesInTotal/invoiceExists", {
          headers,
          params: {
            invNumber: invoiceNR,
            fiscalYear,
          },
        });

        if (isCancelled) {
          return;
        }

        setInvNumberExist(response.data[0].InvoiceCount);
        setInvoiceOtherClientMessage("");
      } catch (error) {
        if (!isCancelled) {
          setInvNumberExist(0);
          setInvoiceOtherClientMessage("");
        }
      }
    };

    validateInvoice();

    return () => {
      isCancelled = true;
    };
  }, [
    isEditMode,
    invoiceNR,
    fiscalYear,
    headers,
  ]);

  const fillFormForEdit = (item) => {
    const safeInvoiceNr = item?.InvoiceNr || "";
    const invoiceDateIso = (item?.Date || "").substring(0, 10);
    const paymentDateIso = (item?.PayDate || item?.Date || "").substring(0, 10);
    const clientAccountId = item?.ClientID || item?.AccountID || "";
    const amount0Value = Number(item?.Amount0 || 0);
    const amount8Value = Number(item?.Amount8 || 0);
    const amount18Value = Number(item?.Amount18 || 0);
    const vat8Value = Number(item?.VAT8 || 0);
    const vat18Value = Number(item?.VAT18 || 0);

    setEditingTransactionId(item?.TransactionID || transactionId || "");
    setInvoiceNR(safeInvoiceNr);
    setInitialInvoiceNr(safeInvoiceNr);
    setDate(invoiceDateIso);
    setPayDate(paymentDateIso);
    setClientID(String(clientAccountId || ""));
    setField(
      clientAccountId
        ? {
            AccountID: clientAccountId,
            AccountName: item?.AccountName || "",
          }
        : null,
    );
    setPaymentOptions(String(item?.PaymentOptions ?? ""));
    setTransactionType(Number(item?.TransactionType || 1));
    setComent(item?.Coment || "");
    setAmount0(amount0Value);
    setAmount8(amount8Value);
    setAmount18(amount18Value);
    setVat8(vat8Value);
    setVat18(vat18Value);
    setValueWithVAT0(amount0Value);
    setValueWithVAT8(amount8Value + vat8Value);
    setValueWithVAT18(amount18Value + vat18Value);
    setInitialFormSnapshot({
      invoiceNR: safeInvoiceNr,
      date: invoiceDateIso,
      payDate: paymentDateIso,
      clientID: String(clientAccountId || ""),
      paymentOptions: String(item?.PaymentOptions ?? ""),
      transactionType: Number(item?.TransactionType || 1),
      coment: item?.Coment || "",
      amount0: round2(amount0Value),
      amount8: round2(amount8Value),
      amount18: round2(amount18Value),
      vat8: round2(vat8Value),
      vat18: round2(vat18Value),
      valueWithVAT0: round2(amount0Value),
      valueWithVAT8: round2(amount8Value + vat8Value),
      valueWithVAT18: round2(amount18Value + vat18Value),
    });
  };

  useEffect(() => {
    let isCancelled = false;

    const initEditMode = async () => {
      if (!isEditMode) {
        setIsInitializing(false);
        return;
      }

      try {
        const response = await axios.get(
          ApiLink.API_URL + `SalesInTotal/view-mode/${transactionId}`,
          { headers },
        );

        if (!isCancelled) {
          fillFormForEdit(response.data);
        }
      } catch (error) {
        if (!isCancelled) {
          errorAlert("Gabim në marrjen e të dhënave për editim.");
          history.push("/Sales/salesintotal");
        }
      } finally {
        if (!isCancelled) {
          setIsInitializing(false);
        }
      }
    };

    initEditMode();

    return () => {
      isCancelled = true;
    };
  }, [isEditMode, headers, transactionId, history]);

  if (isInitializing) {
    return (
      <div className="Unit pit-form-page" style={{ minHeight: "280px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            minHeight: "280px",
          }}
        >
          <CircularProgress size={28} />
        </div>
      </div>
    );
  }

  return (
    <div className="Unit pit-form-page">
      <div className="pit-form-header">
        <div>
          <h2 className="pit-form-title">
            {isEditMode ? "Ndrysho shitjen në total" : "Shitje e re në total"}
          </h2>
          <p className="pit-form-subtitle">
            {isEditMode
              ? "Përditëso fushat e shitjes dhe ruaj ndryshimet."
              : "Plotëso fushat kryesore dhe ruaj faturën e shitjes."}
          </p>
        </div>
        <div className="pit-form-header-actions">
            {!isEditMode && (
              <button
                type="button"
                className="pit-btn pit-btn-secondary"
                onClick={() => {
                  fetchNextInvoiceNr({ resetForm: true });
                }}
                disabled={insertingTransaction}
              >
                Pastro
              </button>
            )}
            <button
              type="button"
              className="pit-btn pit-btn-ghost"
              onClick={handleCloseClick}
              disabled={insertingTransaction}
            >
              Mbyll
            </button>
            <button
              type="submit"
              form="pit-form"
              className={`pit-btn pit-btn-primary${!isEditMode && invNumberExist > 0 ? " invoice-exists" : ""}`}
              disabled={insertingTransaction || (!isEditMode && invNumberExist > 0)}
            >
              {insertingTransaction ? (
                <CircularProgress size={18} style={{ color: "#fff" }} />
              ) : !isEditMode && invNumberExist > 0 ? (
                "Ky numër i faturës ekziston"
              ) : (
                isEditMode ? "Përditëso" : "Ruaj"
              )}
            </button>
        </div>
      </div>

      <form id="pit-form" className="pit-form-body" onSubmit={handleSubmit} noValidate>
        <div className="pit-top-grid">
          <section className="pit-card pit-card-elevated">
            <div className="pit-card-headline">
              <h3 className="pit-card-title">Informacioni i Përgjithshëm</h3>
              <span className="pit-card-chip">Dokumenti</span>
            </div>
            <div className="pit-form-cluster">
              <p className="pit-cluster-title">Detajet e Dokumentit</p>
              <div className="pit-grid two-columns">
                <div className="pit-grid-full">
                  <TextField
                    label="Numri Fatures"
                    fullWidth
                    required
                    inputRef={invoiceNrRef}
                    value={invoiceNR}
                    onChange={(event) => {
                      setInvoiceNR(event.target.value);
                      if (validationErrors.invoiceNR) {
                        setValidationErrors((prev) => ({ ...prev, invoiceNR: "" }));
                      }
                    }}
                    error={(!isEditMode && invNumberExist > 0) || Boolean(validationErrors.invoiceNR)}
                    helperText={
                      !isEditMode && invNumberExist > 0
                        ? "Ky numër i faturës ekziston në listë."
                        : validationErrors.invoiceNR || undefined
                    }
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <TextField
                  label="Data Faturës"
                  type="date"
                  value={date}
                  onChange={(e) => {
                    setDate(e.target.value);
                    setPayDate(e.target.value);
                    if (validationErrors.date) {
                      setValidationErrors((prev) => ({ ...prev, date: "" }));
                    }
                    if (validationErrors.payDate) {
                      setValidationErrors((prev) => ({ ...prev, payDate: "" }));
                    }
                  }}
                  required
                  error={isInvoiceDateOutsideFiscalYear || Boolean(validationErrors.date)}
                  helperText={
                    isInvoiceDateOutsideFiscalYear
                      ? `Data duhet të jetë brenda vitit fiskal ${fiscalYear} (${formatDate(minDate)} - ${formatDate(maxDate)}).`
                      : validationErrors.date || undefined
                  }
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  label="Data pagesës"
                  type="date"
                  value={payDate}
                  onChange={(e) => {
                    setPayDate(e.target.value);
                    if (validationErrors.payDate) {
                      setValidationErrors((prev) => ({ ...prev, payDate: "" }));
                    }
                  }}
                  required
                  error={Boolean(validationErrors.payDate)}
                  helperText={validationErrors.payDate || ""}
                  InputLabelProps={{ shrink: true }}
                />
                <div className="pit-grid-full">
                  <div style={{ display: "flex", alignItems: "center", gap: 0 }}>
                    <div style={{ flex: 1 }}>
                      {isEditMode ? (
                        <AccountsAutocompleteEdit
                          ledgerID={105}
                          textFieldWidth="100%"
                          accountID={clientID}
                          label="Kerko Klientin"
                          labelId="AccountID"
                          onSelect={(account) => {
                            setClientID(account.AccountID);
                            setField(account);
                            if (validationErrors.clientID) {
                              setValidationErrors((prev) => ({ ...prev, clientID: "" }));
                            }
                          }}
                          onClear={() => {
                            setClientID("");
                            setField(null);
                          }}
                        />
                      ) : (
                        <AccountsAutocompleteInsert
                          ledgerID={105}
                          textFieldWidth="100%"
                          value={field}
                          label="Kerko Klientin"
                          labelId="AccountID"
                          onSelect={(account) => {
                            setClientID(account.AccountID);
                            setField(account);
                            if (validationErrors.clientID) {
                              setValidationErrors((prev) => ({ ...prev, clientID: "" }));
                            }
                          }}
                          onClear={() => {
                            setClientID("");
                            setField(null);
                          }}
                        />
                      )}
                    </div>
                    <IconButton
                      size="small"
                      onClick={() => setShowClientModal(true)}
                      aria-label="Shto klient"
                      title="Shto klient"
                      sx={{
                        border: "1px solid #c5d8ce",
                        borderRadius: "8px",
                        color: "#2f5649",
                        fontSize: "22px",
                        fontWeight: 700,
                        width: 48,
                        height: 48,
                        minWidth: 48,
                        minHeight: 48,
                        maxWidth: 48,
                        maxHeight: 48,
                        p: 0,
                        lineHeight: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      +
                    </IconButton>
                  </div>
                  {validationErrors.clientID && (
                    <div
                      style={{
                        marginTop: 6,
                        color: "#d32f2f",
                        fontSize: 12,
                        lineHeight: 1.3,
                      }}
                    >
                      {validationErrors.clientID}
                    </div>
                  )}
                </div>
                {invoiceOtherClientMessage && invNumberExist <= 0 && (
                  <div className="pit-grid-full">
                    <div
                      style={{
                        marginTop: 4,
                        padding: "10px 12px",
                        borderRadius: 8,
                        border: "1px solid #f2c078",
                        background: "#fff8ee",
                        color: "#8b5e1a",
                        fontSize: 12,
                        lineHeight: 1.35,
                      }}
                    >
                      {invoiceOtherClientMessage}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>

          <section className="pit-card pit-card-elevated">
            <div className="pit-card-headline">
              <h3 className="pit-card-title">Klasifikimi</h3>
              <span className="pit-card-chip">Kontabiliteti</span>
            </div>
            <div className="pit-form-cluster">
              <p className="pit-cluster-title">Kategorizimi i Shitjes</p>
              <div className="pit-grid two-columns">
                <div className="pit-grid-full">
                  <TextField
                    label="Llogaria Kontabël"
                    value="702-Te hyrat nga shitja"
                    disabled
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </div>
                <TextField
                  select
                  label="Lloji Shitjes"
                  value={transactionType}
                  onChange={(event) => setTransactionType(event.target.value)}
                  required
                  SelectProps={{
                    MenuProps: paymentMenuProps,
                    IconComponent: sharedDropdownIcon,
                  }}
                  InputProps={{
                    sx: sharedSelectInputSx,
                  }}
                  FormControlProps={{
                    sx: { borderRadius: 8, height: 48, minHeight: 48, maxHeight: 48 },
                  }}
                  InputLabelProps={{ shrink: true }}
                >
                  {TranscationData.map((data) => (
                    <MenuItem key={data.id} value={data.id}>
                      {data.type}
                    </MenuItem>
                  ))}
                </TextField>
                <PaymentTypeSelect
                  value={paymentOptions}
                  onChange={(event) => {
                    setPaymentOptions(event.target.value);
                    if (validationErrors.paymentOptions) {
                      setValidationErrors((prev) => ({ ...prev, paymentOptions: "" }));
                    }
                  }}
                  label="Mënyra Pagesës"
                  error={Boolean(validationErrors.paymentOptions)}
                  helperText={validationErrors.paymentOptions || ""}
                />
                <div className="pit-grid-full">
                  <TextField
                    className="pit-comment"
                    label="Komenti"
                    multiline
                    rows={1}
                    value={coment}
                    onChange={(event) => {
                      setComent(event.target.value);
                    }}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </section>
        </div>

        <section className="pit-card">
          <h3 className="pit-card-title">Vlerat dhe TVSH</h3>
          <div className="pit-vat-table">
            <div className="pit-vat-head">
              <div>Norma TVSH</div>
              <div>Vlera pa TVSH</div>
              <div>Vlera e TVSH</div>
              <div>Total</div>
            </div>

            {isVatDeclarant && (
              <>
                <div className="pit-vat-row">
                  <div className="pit-vat-rate">18%</div>
                  <PriceField
                    label=""
                    name="amount18"
                    value={amount18}
                    onChange={(event) => calculateWithVAT(event.target.value, 18)}
                  />
                  <PriceField
                    label=""
                    name="vat18"
                    value={vat18}
                    onChange={(event) => calculateFromVAT(event.target.value, 18)}
                  />
                  <PriceField
                    label=""
                    name="total18"
                    value={valueWithVAT18}
                    decimalScale={2}
                    onChange={(event) => calculateWithoutVAT(event.target.value, 18)}
                  />
                </div>

                <div className="pit-vat-row">
                  <div className="pit-vat-rate">8%</div>
                  <PriceField
                    label=""
                    name="amount8"
                    value={amount8}
                    onChange={(event) => calculateWithVAT(event.target.value, 8)}
                  />
                  <PriceField
                    label=""
                    name="vat8"
                    value={vat8}
                    onChange={(event) => calculateFromVAT(event.target.value, 8)}
                  />
                  <PriceField
                    label=""
                    name="total8"
                    value={valueWithVAT8}
                    decimalScale={2}
                    onChange={(event) => calculateWithoutVAT(event.target.value, 8)}
                  />
                </div>
              </>
            )}

            <div className="pit-vat-row">
              <div className="pit-vat-rate">0%</div>
              <PriceField
                label=""
                name="amount0"
                value={amount0}
                onChange={(event) => calculateWithVAT(event.target.value, 0)}
              />
              <PriceField label="" name="vat0" value={0} disabled />
              <PriceField
                label=""
                name="total0"
                value={valueWithVAT0}
                decimalScale={2}
                onChange={(event) => calculateWithoutVAT(event.target.value, 0)}
              />
            </div>
          </div>

          <div className="pit-vat-totals-row">
            <div className="pit-vat-totals-label">Totale</div>
            <div className="pit-vat-total-item">
              <span>Total pa TVSH</span>
              <strong>{formatEuroValue(Number(amount0) + Number(amount8) + Number(amount18))} €</strong>
            </div>
            <div className="pit-vat-total-item">
              <span>Total TVSH</span>
              <strong>{formatEuroValue(Number(vat8) + Number(vat18))} €</strong>
            </div>
            <div className="pit-vat-total-item grand-total">
              <span>Total me TVSH</span>
              <strong>
                {formatEuroValue(
                  Number(amount0) +
                    Number(amount8) +
                    Number(amount18) +
                    Number(vat8) +
                    Number(vat18),
                )}{" "}
                €
              </strong>
            </div>
          </div>
        </section>
      </form>

      <ClientsModal
        show={showClientModal}
        onHide={() => setShowClientModal(false)}
        mode="insert"
        type="none"
      />

      <Dialog
        open={showCloseConfirm}
        onClose={() => setShowCloseConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Konfirmo mbylljen</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ke ndryshime të paruajtura. Nëse mbyll këtë formë, të dhënat e
            pa-ruajtura do të humbin. A je i sigurt që dëshiron të vazhdosh?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setShowCloseConfirm(false)} color="inherit">
            Anulo
          </Button>
          <Button
            onClick={() => {
              setShowCloseConfirm(false);
              closePage();
            }}
            variant="contained"
            sx={{ backgroundColor: "#2f5649", "&:hover": { backgroundColor: "#284945" } }}
          >
            Po, mbylle
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={duplicateInvoiceDialog.open}
        onClose={closeDuplicateInvoiceDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            border: "1px solid #d4e2db",
            boxShadow: "0 24px 60px rgba(31, 58, 54, 0.16)",
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 1,
            background: "linear-gradient(135deg, #e9f1ed 0%, #f5f9f7 100%)",
            color: "#1f3a36",
            fontWeight: 700,
          }}
        >
          {duplicateInvoiceDialog.title}
        </DialogTitle>
        <DialogContent sx={{ px: 3, pt: 3, pb: 2 }}>
          <div
            style={{
              marginBottom: 16,
              padding: "12px 14px",
              borderRadius: 12,
              border: "1px solid #d4e2db",
              background: "#f5f9f7",
              color: "#1f3a36",
              fontSize: 14,
              lineHeight: 1.6,
              fontWeight: 600,
            }}
          >
            {duplicateInvoiceDialog.message}
          </div>
          <DialogContentText sx={{ color: "#35554a", lineHeight: 1.7 }}>
            {duplicateInvoiceDialog.details}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={closeDuplicateInvoiceDialog}
            variant="contained"
            sx={{
              textTransform: "none",
              px: 2.5,
              borderRadius: 2,
              backgroundColor: "#284945",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#1f3a36",
                boxShadow: "none",
              },
            }}
          >
            E kuptova
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={fiscalDateDialog.open}
        onClose={closeFiscalDateDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            border: "1px solid #d4e2db",
            boxShadow: "0 24px 60px rgba(31, 58, 54, 0.16)",
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 1,
            background: "linear-gradient(135deg, #e9f1ed 0%, #f5f9f7 100%)",
            color: "#1f3a36",
            fontWeight: 700,
          }}
        >
          {fiscalDateDialog.title}
        </DialogTitle>
        <DialogContent sx={{ px: 3, pt: 3, pb: 2 }}>
          <div
            style={{
              marginBottom: 16,
              padding: "12px 14px",
              borderRadius: 12,
              border: "1px solid #d4e2db",
              background: "#f5f9f7",
              color: "#1f3a36",
              fontSize: 14,
              lineHeight: 1.6,
              fontWeight: 600,
            }}
          >
            {fiscalDateDialog.message}
          </div>
          <DialogContentText sx={{ color: "#35554a", lineHeight: 1.7 }}>
            {fiscalDateDialog.details}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={closeFiscalDateDialog}
            variant="contained"
            sx={{
              textTransform: "none",
              px: 2.5,
              borderRadius: 2,
              backgroundColor: "#284945",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#1f3a36",
                boxShadow: "none",
              },
            }}
          >
            E kuptova
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SalesInTotalForm;
